import type { Timezone } from '@biteinc/enums';
import { Time } from '@biteinc/helpers';

export namespace TimeHelper {
  export const FullDateFormat = 'MMMM Do YYYY, HH:mm:ss';

  export function localMoment(timestamp?: number | Date): Time.Moment {
    return Time.moment(timestamp || new Date(), Time.guess());
  }

  export function format(
    timestamp: number | Date = Date.now(),
    outputFormat: string = 'MM/DD HH:mm',
  ): string {
    return localMoment(timestamp).format(outputFormat);
  }

  export function displayDateFromTimestamp(timestamp: number, timezone?: Timezone): string {
    const moment = Time.moment(timestamp, timezone || Time.guess());
    let outputFormat = 'ddd MM/DD h:mma';
    // Show the year if this is from more than a year ago.
    if (moment.isBefore(Time.moment(new Date(), timezone || Time.BITE_TZ).subtract(1, 'year'))) {
      outputFormat = 'ddd MM/DD/YYYY h:mma';
    }
    if (timezone && Time.guess() !== timezone) {
      outputFormat += ' z';
    }
    return moment.format(outputFormat);
  }

  export function durationFromTimestamp(timestamp: number, includeSeconds?: boolean): string {
    let duration = '';
    let seconds = Math.floor(timestamp / 1000);
    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    if (days >= 1) {
      duration += `${days}day${days === 1 ? '' : 's'} `;
    }
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    if (hours >= 1) {
      duration += `${hours}hr${hours > 1 ? 's' : ''} `;
    }
    const mins = includeSeconds ? Math.floor(seconds / 60) : Math.ceil(seconds / 60);
    if (mins) {
      duration += `${mins}min`;
    }
    if (includeSeconds) {
      if (duration.length) {
        duration += ' ';
      }
      duration += `${seconds % 60}s`;
    }
    return duration;
  }

  export function roughDurationFromTimestamp(timestamp: number): string {
    let duration = '';
    let seconds = Math.floor(timestamp / 1000);
    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    if (days >= 1) {
      duration += `${days}day${days === 1 ? '' : 's'} `;
    }
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    if (hours >= 1 && days < 4) {
      duration += `${hours}hr${hours > 1 ? 's' : ''} `;
    }
    const mins = Math.floor(seconds / 60);
    if (hours < 2 && mins && days < 1) {
      duration += `${mins}min`;
    }
    if (mins < 10 && hours < 1 && days < 1) {
      duration += ` ${seconds % 60}s`;
    }
    return duration;
  }

  export function timeAgoStrFromNow(timestamp: number): string {
    return roughDurationFromTimestamp(Date.now() - timestamp);
  }
}
